import type { QueryClient } from '@tanstack/react-query'
import type { Store } from '@tanstack/react-store'

import { isDemoModeActive } from '@/lib/demo-mode'
import { organizationStore } from '@/stores/organization.store'
import type { AuthState } from '@/stores/auth.store'

type PrefetchQueryOptions = Parameters<QueryClient['prefetchQuery']>[0]

export function canPreloadOrganizationQueries(auth: Store<AuthState>) {
  return (!!auth.state.session || isDemoModeActive()) && !!organizationStore.state.selectedOrganizationId
}

export function preloadQueries(queryClient: QueryClient, queries: readonly unknown[]) {
  for (const queryOptions of queries) {
    void queryClient.prefetchQuery(queryOptions as PrefetchQueryOptions)
  }
}
